<template>
<div class="chapter">
<div class="inner_page">
<h1 class="center" id="TOC">Contents</h1>
<p class="toc1"><a href="#/xhtml/chapter01">Chapter One: A Sinister Welcome</a></p>
<p class="toc1"><a href="#/xhtml/chapter02">Chapter Two: The Stolen Painting</a></p>
<p class="toc1"><a href="#/xhtml/chapter03">Chapter Three: Murdock Follows A Hunch</a></p>
<p class="toc1"><span href="#/xhtml/chapter04" title="Link target outside of Sample">Chapter Four: “Murder’s My Business.”</span></p>
<p class="toc1"><span href="#/xhtml/chapter05" title="Link target outside of Sample">Chapter Five: Picture Puzzle</span></p>
<p class="toc1"><span href="#/xhtml/chapter06" title="Link target outside of Sample">Chapter Six: Double-Barreled Mission</span></p>
<p class="toc1"><span href="#/xhtml/chapter07" title="Link target outside of Sample">Chapter Seven: Million-Dollar Secret</span></p>
<p class="toc1"><span href="#/xhtml/chapter08" title="Link target outside of Sample">Chapter Eight: The Lure Of Fine Art</span></p>
<p class="toc1"><span href="#/xhtml/chapter09" title="Link target outside of Sample">Chapter Nine: At The Silver Door</span></p>
<p class="toc1"><span href="#/xhtml/chapter10" title="Link target outside of Sample">Chapter Ten: Unseen Danger</span></p>
<p class="toc1"><span href="#/xhtml/chapter11" title="Link target outside of Sample">Chapter Eleven: The Reluctant Artist</span></p>
<p class="toc1"><span href="#/xhtml/chapter12" title="Link target outside of Sample">Chapter Twelve: The Smell Of Death</span></p>
<p class="toc1"><span href="#/xhtml/chapter13" title="Link target outside of Sample">Chapter Thirteen: The Only Lie</span></p>
<p class="toc1"><span href="#/xhtml/chapter14" title="Link target outside of Sample">Chapter Fourteen: No Canaries Sing</span></p>
<p class="toc1"><span href="#/xhtml/chapter15" title="Link target outside of Sample">Chapter Fifteen: Three Come Calling</span></p>
<p class="toc1"><span href="#/xhtml/chapter16" title="Link target outside of Sample">Chapter Sixteen: Alarm In The Dark</span></p>
<p class="toc1"><span href="#/xhtml/chapter17" title="Link target outside of Sample">Chapter Seventeen: A Lady Afraid</span></p>
<p class="toc1"><span href="#/xhtml/chapter18" title="Link target outside of Sample">Chapter Eighteen: A Killer Comes Close</span></p>
<p class="toc1"><span href="#/xhtml/chapter19" title="Link target outside of Sample">Chapter Nineteen: Face To Face</span></p>
<p class="toc1"><span href="#/xhtml/chapter20" title="Link target outside of Sample">Chapter Twenty: Waiting For Beautiful</span></p>
<p class="toc1"><span href="#/xhtml/chapter21" title="Link target outside of Sample">Chapter Twenty-One: The Odds Catch Up</span></p>
<p class="toc1"><span href="#/xhtml/chapter22" title="Link target outside of Sample">Chapter Twenty-Two: Murder Was A Word</span></p>
<p class="toc1"><span href="#/preview/preview" title="Link target outside of Sample">Preview: The Fifth Key</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?8966c66c